import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import { Provider } from 'react-redux';
import step from './reducers';
import thunk from 'redux-thunk';
import * as API from '../api';
import * as CaseApi from 'saas/pco/cases/api';
import $ from 'jquery';
import { getIsDirty } from './reducers/dirty';
import { withCurrentReferer } from 'plugins/contextual-back';
import * as WorkerApi from 'saas/users/api';
import { error } from 'plugins/toastr';

// Lots of redundant code with saas/pco/cases/study
function handleStudySchedule(id, store, root) {
  const $multiButton = $('#bt-multi-schedule-study');

  $multiButton.on('click', evt => {
    $multiButton.addClass('loading');

    Promise.all([WorkerApi.getAllWorkers(), CaseApi.getSitesByCase(id)]).then(
      response => response
    );
  });
}

export default function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('creation-step-2');
  const modalRoot = document.getElementById('modal-root');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');

  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#creation-step-2 form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  handleStudySchedule(id, store, modalRoot);

  ReactDOM.render(
    <Provider store={store}>
      <Page id={parseInt(id, 10)} customerId={parseInt(customerId, 10)} />
    </Provider>,
    root
  );

  const update = (id, step, next) => {
    const form = store.getState().form;

    API.update(id, step, form, next).then(
      res => window.location.replace(withCurrentReferer(res.url)),
      err => {
        console.debug(err);
        if (err.res.status === 409) {
          err.res.text().then(message => error(message));
        } else {
          error('Une erreur est survenue pendant la sauvegarde ');
        }
      }
    );
  };

  const cleanDirty = () => $('#creation-step-2 form').removeClass('dirty');

  const saveButton = document.getElementById('bt-save');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    const step = saveButton.getAttribute('data-step');
    const next = saveButton.getAttribute('data-next');
    saveButton.onclick = () => {
      cleanDirty();
      update(id, step, next);
    };
  }

  const finishButton = document.getElementById('bt-finish');
  if (finishButton) {
    const id = finishButton.getAttribute('data-id');
    const step = finishButton.getAttribute('data-step');
    const next = finishButton.getAttribute('data-next');
    finishButton.onclick = () => {
      cleanDirty();
      update(id, step, next);
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/cases-creation/step2/index.js